import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Navigation.css';

const Navigation = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`navigation ${scrolled ? 'scrolled' : ''}`}>
      <div className="nav-container">
        <Link to="/" className="nav-logo">
          <span className="logo-text">DWG</span>
          <span className="logo-accent">LABS</span>
        </Link>
        
        <div className="nav-links">
          <a href="#apps" className="nav-link">Apps</a>
          <a href="#stats" className="nav-link">Impact</a>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
